<script lang="ts">
  import { _ } from 'svelte-i18n';
  import dayjs from 'dayjs';
  import { pluralizeI18n } from '../../etc/utils';
  import { AppState } from '../../etc/stores';
  import Label from '../typography/Label.svelte';
  import { replaceVariables } from '../../i18n';

  export let item: any;

  const t = (text: string, values?: Record<string, any>) => {
    return replaceVariables($_(`referral.tracking.${text}`), values);
  };

  const actions = {
    purchased: {
      text: t('purchased'),
      style: 'friend-item__purchased',
      icon: 'purchased.svg'
    },
    joined: {
      text: t('joined'),
      style: 'friend-item__joined',
      icon: 'joined.svg'
    }
  };

  const getAction = () => {
    return actions[item.type];
  };

  const action = getAction();

  const { coins } = item;
</script>

<div
  class="friend-item"
  style="background-color: {$AppState.theme.colors.referral.tracking
    .backgroundItem};"
>
  <div class="friend-item__left">
    <Label type="medium-regular-semibold" class="friend-item__name"
      >{item.name} {item.lastname}</Label
    >
    <Label type="medium-regular" class="friend-item__date"
      >{dayjs(item.createdAt).format('MM/DD/YY')}</Label
    >
  </div>
  <div class="friend-item__right">
    <p class="friend-item__action {action.style}">
      {action.text}
      <i
        style="background: url({process.env
          .BASE_URL}/images/{action.icon}) no-repeat center;"
      />
    </p>
    {#if coins && item.type === 'purchased'}
      <Label type="medium-regular" class="friend-item__coins">
        {t(pluralizeI18n('purchased-coin', coins), { coins: +coins })}
      </Label>
    {/if}
  </div>
</div>

<style lang="scss">
  :global(.friend-item__name) {
    opacity: 0.8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 135px;
    margin-bottom: 10px !important;
  }

  :global(.friend-item__date) {
    opacity: 0.8;
  }

  :global(.friend-item__coins) {
    opacity: 0.8;
    text-align: end;
  }

  .friend-item {
    display: flex;
    padding: 14px 12px;
    border-radius: 12px;
    box-sizing: content-box;
    justify-content: space-between;

    &__action {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      margin-bottom: 10px;
      display: flex;
      i {
        height: 16px;
        width: 16px;
        display: block;
        margin-left: 2px;
      }
    }
    &__purchased {
      color: #39b989;
    }
    &__joined {
      color: #1877cc;
    }
  }
</style>
